// Help text for the common action-property types and well-known field names.
// Keys are lowercased; lookup is best-effort.

const TYPE_HINTS: Record<string, string> = {
  fileid:
    'Reference to a file stored in the platform. Typically produced by a previous step or supplied as a processing-job input.',
  boolean: 'True / false flag.',
  integer: 'Whole number.',
  floatingnumber: 'Decimal number.',
  dimensions: 'Width / height in pixels.',
  detectedobject: 'A region detected in an image (bounding box + label).',
  piiextractiontargets: 'List of personal-info fields to extract (names, BSN, etc.).',
  classify: 'Classification result with category labels and confidence.',
  condition: 'Result of a checkCondition step.',
  any: 'Any JSON value.',
  text: 'Plain text string.',
  operator: 'Comparison operator used inside conditions.',
  cutoutid: 'Identifier of a cut-out region from an image.',
  riskassessment: 'Risk-scoring result.',
  aggregateddocumentdata: 'Combined per-document extraction output.',
  crossmatchresult: 'Cross-document data comparison result.',
  externalsourcedata: 'Data fetched from an external integration.',
  aisettings: 'Configuration for an LLM call: model, temperature, prompt selection, MCP tools.',
  parsedemail: 'Parsed email message (from, to, subject, body, attachments).',
  stringdictionary: 'Key/value pairs (all strings).',
  routedefinition: 'A named branch with a condition expression deciding when it is taken.',
  string: 'Text value.',
  number: 'Number value.',
  object: 'Structured object value.',
};

const FIELD_HINTS: Record<string, string> = {
  fileid:
    'The file to process. Either drag a file output from a previous step or use a ProcessingJob input.',
  fileids: 'List of files to process.',
  pdffileid: 'A converted PDF file from a previous step (e.g. ConvertToPdf output).',
  excludeattachments: 'When true, ignore email or PDF attachments while processing.',
  textlayerjsonid: 'File ID for a structured text-layer JSON (output of ExtractPdfPageText).',
  levelofdetail: 'How much detail to extract — affects cost and accuracy.',
  conditionexpression: 'Scriban expression evaluated to decide if this branch / step runs.',
  expression:
    'Scriban expression. Use {{ stepId.outputName }} or {{ input.fieldName }} to reference values.',
};

export const getTypeHint = (typeName: string | undefined | null): string | null => {
  if (!typeName) return null;
  return TYPE_HINTS[typeName.toLowerCase()] ?? null;
};

export const getFieldHint = (fieldName: string | undefined | null): string | null => {
  if (!fieldName) return null;
  return FIELD_HINTS[fieldName.toLowerCase()] ?? null;
};

/** Common ProcessingJobInput target keys. Used as autocomplete suggestions. */
export const COMMON_PROCESSING_JOB_INPUTS = ['FileId', 'FileIds', 'ProcessingJobId', 'Metadata'];
